
export default class ResponseDataModel {
  constructor() {
    this._data = {
      lines: 0,
      current: '',
      actions: '',
      action: '',
    }
  }

  get() {
    return this._data
  }

  set(value) {
    this._data.action = value.context.actions[0]
    this._data.actions = value.context.actions
    this._data.current = value.context.current
  }
}
